import api from './api';

export const partnerService = {
  list(params = {}) {
    return api.get('/api/partner/partners', { params }).then(r => r.data);
  },

  get(id) {
    return api.get(`/api/partner/partners/${id}`).then(r => r.data.partner);
  },

  create(payload) {
    return api.post('/api/partner/partners', payload).then(r => r.data.partner);
  },

  update(id, payload) {
    return api.put(`/api/partner/partners/${id}`, payload).then(r => r.data.partner);
  },

  remove(id) {
    return api.delete(`/api/partner/partners/${id}`).then(r => r.data);
  },

  updateBilling(id, payload) {
    return api.patch(`/api/partner/partners/${id}/billing`, payload).then(r => r.data.partner);
  },

  getDevices(id) {
    return api.get(`/api/partner/partners/${id}/devices`).then(r => r.data.allowedDevices);
  },

  updateDevices(id, allowedDevices) {
    return api
      .put(`/api/partner/partners/${id}/devices`, { allowedDevices })
      .then(r => r.data);
  },

  listApiKeys(partnerId, includeRevoked = false) {
    return api
      .get(`/api/partner/partners/${partnerId}/api-keys`, {
        params: { includeRevoked: includeRevoked ? 'true' : 'false' },
      })
      .then(r => r.data.apiKeys);
  },

  createApiKey(partnerId, payload = {}) {
    return api.post(`/api/partner/partners/${partnerId}/api-keys`, payload).then(r => r.data);
  },

  rotateApiKey(keyId) {
    return api.post(`/api/partner/api-keys/${keyId}/rotate`).then(r => r.data);
  },

  revokeApiKey(keyId) {
    return api.post(`/api/partner/api-keys/${keyId}/revoke`).then(r => r.data);
  },

  getUsage(partnerId, params = {}) {
    return api.get(`/api/partner/partners/${partnerId}/usage`, { params }).then(r => r.data.usage);
  },

  getTodayUsage(partnerId) {
    return api.get(`/api/partner/partners/${partnerId}/usage/today`).then(r => r.data.today);
  },
};

export default partnerService;
